import axios from "axios";
import type { AxiosError, AxiosResponse, AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import { ENVIRONMENT } from "../entities/Environment";
import { getCurrentLanguageId } from "../lang/utils";

// The initial instance of axios
export const client = (() => {
  return axios.create({
    baseURL: ENVIRONMENT.DEV,
    headers: {
      Accept: "application/json, text/plain, */*",
    },
  });
})();

const request = async (options: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse) => {
    const { data } = response;
    return data;
  };

  const onError = function (error: AxiosError) {
    return Promise.reject({
      message: error.message,
      code: error.code,
      response: error.response,
    });
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;

client.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const languageId = getCurrentLanguageId();
    if (languageId && config.headers) {
      config.headers["Language-ID"] = languageId;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);
